// @flow

/**
 * Clipped For Export
 * Wraps the inactive pane during export so it has real layout — allowing
 * ResponsiveContainer to measure its width and html2canvas to capture its
 * charts — without being visible. Uses height:0 + overflow:hidden rather than
 * display:none/visibility:hidden, which html2canvas cannot capture. Only
 * mounted while exportMode is true, and always rendered aria-hidden.
 */

import React from 'react';
import styled from 'styled-components';

const ClippedContainer = styled.div`
  height: 0;
  overflow: hidden;
  pointer-events: none;
`;

type Props = {
  children?: React$Node,
};

const ClippedForExport = ({ children }: Props): React$Node => (
  <ClippedContainer aria-hidden="true">{children}</ClippedContainer>
);

export default ClippedForExport;
